




























































import { Vue, Component, Prop } from "vue-property-decorator";
import { Product, ProductImageSize } from "@/loader";

@Component
export default class ProductLeaf extends Vue {
	@Prop({ type: Object, required: true })
	public item!: Product;

	public get classes() {
		return ['container-fluid product-leaf', {
			'quotation': this.item.only_quotation,
			'discount': !!this.item.price.default.discount,
			'no-image': !this.image,
		}];
	}

	public get category() {
		return this.item.categories.length ? this.item.categories[this.item.categories.length - 1] : null;
	}

	public get url(): string {
		return `https://www.laboandco.com/${this.item.url_key}`;
	}

	public get categoryUrl(): string {
		return this.category ? `https://www.laboandco.com/${this.category.url_key}` : "";
	}

	public get image(): ProductImageSize | null {
		return this.item.images?.[0]?.medium || null;
	}

	public get taxSuffix() {
		return this.item.price.default.tax_included ? "TTC" : "HT";
	}
}
